import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Image from "@/bit/components/components.c-image";
import Icon from "@/bit/components/components.icon-glyph";
import Label, { LABEL_TYPE } from "@/bit/components/components.label";
import TextInfo, {
  TEXT_COLOR,
  TEXT_FONT_WEIGHT,
  TEXT_SIZE,
  TEXT_KIND,
  TEXT_HEADING_LEVEL,
} from "@/bit/components/components.text";
import Price from "@/bit/components/components.price";
import Card from "@/component/card";

import styles from "./style";

const DeviceCard = ({
  onClick,
  href,
  hash,
  cydata,
  labelPromo,
  labelSaving,
  image,
  name,
  bottomCardTextRenew,
  bottomCardText,
  wrapperClass,
  offers,
  stamp
}) => {

  return (
    <>
      <section className={`device-card ${wrapperClass || ""}`} data-cy={cydata}>
        <Card
          className="device-card-position device-card-height"
          cardPropLayout="device"
          onClick={onClick}
          title={name}
          href={href}
          taggingInfo={{
            componentContent: `Dispositivo ${name}`,
            componentName: "device-card",
          }}
          isDeviceCard
        >
          {labelPromo && labelPromo.text && (
            <Label
              className="crazy-label"
              cydata="labelPromoEntrega"
              theme={LABEL_TYPE.GIFT}
              label={labelPromo.text}
              customColors={labelPromo.kind ? {
                background: labelPromo.kind,
                color: 'white'
              } : {}}
              notBorderRadius
            />
          )}
          <div className="device-card--container">
            <div className="device-card--container--image-stamp-container">
              {stamp && stamp.icon ? (
                <div className="device-card--container--image-stamp-container--stamp" style={{ justifyContent: stamp.align }}>
                  <Icon
                    id={stamp.icon}
                    width={stamp.width || 200}
                    height="auto"
                    position="right"
                  />
                </div>
              ) : (
                stamp && stamp.img && (
                  <div className="device-card--container--image-stamp-container--stamp" style={{ justifyContent: stamp.align }}>
                    <Image
                      src={stamp.img}
                      title={name}
                      alt={name}
                      hash={hash}
                      height={100}
                      width={stamp.width || 200}
                      cydata="mainImageCardIn"
                    />
                  </div>
                )
              )}
              <div
                className={`device-card--container--image-stamp-container--image-box ${stamp ? 'with-stamp' : ''}`}
                data-cy="mainImageCard"
              >
                <Image
                  src={image}
                  title={name}
                  alt={name}
                  hash={hash}
                  objectFit="contain"
                  fill
                  cydata="mainImageCardIn"
                />
              </div>
            </div>
            <div
              className="device-card--container--name"
              data-cy="productNameTitle"
            >
              <TextInfo
                className="device-card--container--name--text"
                text={name}
                size={TEXT_SIZE.SUBTITLE1}
                color={TEXT_COLOR.BLUE_DARK}
                fontType={TEXT_FONT_WEIGHT.BOLD}
                kind={TEXT_KIND.HEADING}
                level={TEXT_HEADING_LEVEL.H3}
                cydata="productNameTitleIn"
              />
            </div>
            <div
              className="device-card--container--label"
              data-cy="labelPromoAhorro"
            >
              <Label
                theme={LABEL_TYPE.DISCOUNT}
                label={labelSaving}
                notBorderRadius
                cydata="labelPromoAhorroIn"
              />
            </div>
            {stamp && stamp.postSavingText && (
              <div
                className="device-card--container--post-saving"
                data-cy="productPostSaving"
              >
                <TextInfo
                  className="device-card--container--post-saving--text"
                  text={stamp.postSavingText}
                  size={TEXT_SIZE.CAPTION3}
                  color={TEXT_COLOR.RED_DARK}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                  kind={TEXT_KIND.HEADING}
                  level={TEXT_HEADING_LEVEL.H3}
                  cydata="productPostSavingIn"
                />
              </div>
            )}
            {
              offers && Object.keys(offers).map((offerKey, index) => (
                offers[offerKey] && offers[offerKey].finalPrice !== null && (
                  <Fragment key={offerKey}>
                    {offers[offerKey].title && (
                      <div className="device-card--container--pack-title">
                        <TextInfo
                          text={offers[offerKey].title}
                          size={TEXT_SIZE.CAPTION}
                          color={TEXT_COLOR.GREY5}
                          fontType={TEXT_FONT_WEIGHT.REGULAR}
                        />
                      </div>
                    )}
                    <div
                      className="device-card--container--price-box"
                      data-cy="priceBox"
                    >
                      {offers[offerKey].priceBeforeDiscounts && (
                        <>
                          <div
                            className="device-card--container--price-box--relative"
                            data-cy="normalFreePriceBefore"
                          >
                            <Price
                              price={offers[offerKey].priceBeforeDiscounts}
                              currency={offers[offerKey].currency}
                              size="xs"
                              color={TEXT_COLOR.GREY5}
                              fontType={TEXT_FONT_WEIGHT.REGULAR}
                              cydata="normalFreePriceBeforeIn"
                            />
                            <div className="device-card--container--line-through" />
                          </div>
                        </>
                      )}
                      <div
                        className="device-card--container--price-box--relative"
                        data-cy="normalPriceBefore"
                      >
                        <Price
                          price={offers[offerKey].finalPrice}
                          currency={offers[offerKey].currency}
                          quote={offers[offerKey].quote}
                          size="xs"
                          color={offers[offerKey].priceBeforeDiscounts || offers[offerKey].forcePromo ? TEXT_COLOR.RED_DARK : TEXT_COLOR.BLUE_DARK}
                          fontType={TEXT_FONT_WEIGHT.BOLD}
                          cydata="normalPriceBeforeIn"
                        />
                      </div>
                    </div>
                    {(offerKey === "r2r" || offerKey === "r2rAdditional") && offers.libre && (
                      <div className="device-card--container--line-freeOffer" />
                    )}
                  </Fragment>
                )
              ))
            }
          </div>

          <>
            {bottomCardTextRenew && (
              <div className="device-card--container--bottom-text">
                <TextInfo
                  text={bottomCardTextRenew}
                  className="additionalPayment"
                  size={TEXT_SIZE.CAPTION}
                  color={TEXT_COLOR.GREY5}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                />
              </div>
            )}

            {bottomCardText && (
              <div className="device-card--container--bottom-text">
                {/* Si hay oferta de libre, requiere añadir separador superior*/}
                <div className="device-card--container--line-freeOffer" />
                <TextInfo
                  text={bottomCardText}
                  className="additionalPayment"
                  size={TEXT_SIZE.CAPTION}
                  color={TEXT_COLOR.GREY5}
                  fontType={TEXT_FONT_WEIGHT.REGULAR}
                />
              </div>
            )}
          </>
        </Card>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};


DeviceCard.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string.isRequired,
  hash: PropTypes.string,
  cydata: PropTypes.string,
  labelPromo: PropTypes.shape({
    text: PropTypes.string.isRequired,
    kind: PropTypes.string,
  }),
  labelSaving: PropTypes.string,
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  financing: PropTypes.bool,
  bottomCardText: PropTypes.string,
  wrapperClass: PropTypes.string,
  offers: PropTypes.objectOf(PropTypes.shape({
    title: PropTypes.string,
    finalPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    priceBeforeDiscounts: PropTypes.number,
    currency: PropTypes.string,
    quote: PropTypes.string,
  })),
};

DeviceCard.defaultProps = {
  hash: "",
  cydata: "",
  labelPromo: null,
  labelSaving: "",
  financing: false,
  bottomCardText: "",
  wrapperClass: "",
  offers: null,
};

export default DeviceCard;
